module.exports = __webpack_public_path__ + "img/ec1.994538ea.jpg";